import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Divider, Form, Input, Modal, Row } from "antd";
import UserProfileForm from "./ProfileForm";
import MyButton from "./Button";
import CustomerForm from "./CustomerForm";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import {
  SearchOutlined,
  PlusOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import { mockCustomer } from "./CustomerList";
import CustomerModal from "./CustomerModal";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "antd/es/form/Form";

// import { useState } from "react";

const CustomerListItem = (props) => {
  const isDesktop = useIsDesktop();

  const { customer, handleClickCustomer, search } = props;

  // const name = _.size(customer) > 0 ? _.get(customer, 'serialNo') : search;
  // const phone = _.get(customer, 'assetName');
  // const email = _.get(customer, 'customerContactEmail');
  // const remark = _.get(customer, 'remark');

  const id = _.get(customer, "serialNo");
  const name = _.get(customer, "assetName");
  const phone = _.get(customer, "customerDetail.phone");
  const email = _.get(customer, "customerContactEmail");
  const remark = _.get(customer, "remark");

  return (
    <div
      className="d-flex align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() =>
        handleClickCustomer(_.size(customer) > 0 ? _.get(customer, "id") : "")
      }
    >
      {/* <div className="d-flex" style={{ flex: "1" }} onClick={onClickView}> */}
      {customer ? (
        <Row className="w-100">
          <Col span={isDesktop ? 24 : 24}>
            <Typography className={`${isDesktop ? "" : "pb-2"}`}>
              {id + " " + name}
            </Typography>
          </Col>
        </Row>
      ) : null}
    </div>
  );

  // return (
  //   <div
  //     className='d-flex align-items-center'
  //     style={{ cursor: 'pointer' }}
  //     onClick={() => handleClickCustomer(_.size(customer) > 0 ? _.get(customer, 'customerContactId') : '')}
  //   >
  //     {/* <div className="d-flex" style={{ flex: "1" }} onClick={onClickView}> */}
  //     <Row className='w-100'>
  //       <Col span={isDesktop ? 7 : 24}>
  //         <Typography isBold className={`${isDesktop ? '' : 'pb-2'}`}>
  //           {name}
  //         </Typography>
  //       </Col>
  //       <Col span={isDesktop ? 16 : 24} className='d-flex'>
  //         <Typography className='px-3'>
  //           {phone}
  //           {_.size(email) > 0 ? ',' : null} {email}
  //         </Typography>
  //         <Typography>{remark}</Typography>
  //       </Col>
  //     </Row>
  //   </div>
  // );
};

const SelectCustomerModal = (props) => {
  const {
    isOpen,
    onCancle,
    customerData,
    setIsOpenSelectCustomer,
    setCustomerData,
    setEvent,
    formCustomer,
    handleSelectName,
    tempDataCus,
    setTempDataCus,
    setSearchCustomer,
  } = props;

  const isDesktop = useIsDesktop();

  const [form] = Form.useForm();

  const [isOpenCustomerModal, setIsOpenCustomerModal] = useState(false);
  // const [searchCustomer, setSearchCustomer] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [tempSearchArray, setTempSearchArray] = useState([]);
  const intl = useIntl();
  const [formSearch] = Form.useForm();
  const [isTemp, setIsTemp] = useState(true);
  console.log("tempSearchArray", tempSearchArray);
  // //console.log('SelectValues', customerData);
  // useEffect(() => {
  //   if (isTemp === false) {
  //     handleTempCreate();
  //   } else {
  //     setTempSearchArray(customerData);
  //   }
  // }, [isOpen, customerData]);

  // const handleTempCreate = () => {
  //   if (_.size(tempDataCus) > 0) {
  //     if (
  //       _.findIndex(customerData, {
  //         customerContactId: _.get(
  //           _.findLast(tempDataCus),
  //           "customerContactId"
  //         ),
  //       }) === -1
  //     ) {
  //       const newData = [...customerData, _.findLast(tempDataCus)];
  //       setCustomerData(newData);
  //       setTempSearchArray(newData);
  //     }
  //   } else {
  //     setTempSearchArray(customerData);
  //   }
  // };

  const handleCancelCustomerForm = () => {
    form.resetFields();
    formSearch.resetFields();
    setIsOpenCustomerModal(false);
    setIsOpenSelectCustomer(true);
  };

  const handleSerchCustomer = (values) => {
    setSearchCustomer(values)
    // setTempSearchArray(customerData);
    // if (values === "") {
    //   setTempSearchArray([]);
    //   setTempSearchArray(customerData);
    // } else {
    //   const searchTerm = values.toLowerCase();
    //   const terms = searchTerm.toLowerCase().split(" ").filter(Boolean);
    //   const Search = _.filter(customerData, (item) => {
    //     const asset = item.assetName.toLowerCase();
    //     const serial = item.serialNo.toLowerCase();
    //     return terms.every(term =>
    //       asset.includes(term) || serial.includes(term)
    //     );
    //   });
    //   setTempSearch(values);
    //   setTempSearchArray(Search);
    // }
  };

  const handleClickCustomer = (values) => {
    formCustomer.setFieldsValue({
      customer: values,
    });

    console.log("idididid", values);

    handleSelectName(values);

    setIsOpenSelectCustomer(false);
  };

  const handleClickSearchCustomer = () => {
    // form.setFieldsValue({
    //   name: searchCustomer,
    // });
    // setSearchCustomer(tempSearch);
    setIsOpenCustomerModal(true);
    // onCancle();
  };

  const handleClickCreate = () => {
    setSearchCustomer("");
    setIsOpenCustomerModal(true);
    // onCancle();
  };

  const handlecloseThisModal = () => {
    setTempSearch("");
    setSearchCustomer("");
    formSearch.resetFields();
    handleSerchCustomer("");
    // setEvent((current) => !current);
    onCancle();
  };

  //       <CustomerAddressModal
  //         isOpen={isOpenCustomerAddressModal}
  //         onCancle={handleCancelCustomerAddressForm}
  //         isEdit={isEdit}
  //       />

  const handleClearInput = () => {
    setTempSearch("");
  };

  //console.log("customerData", customerData)

  return (
    <>
      <Modal
        title={
          <Typography
            color={COLORS.Primary}
            isBold
            size="16px"
            className={isDesktop ? "pb-3" : "text-center pb-2"}
          >
            <FormattedMessage
              id="modalSelectCustomer"
              defaultMessage="Select Customer"
            />
          </Typography>
        }
        open={isOpen}
        onOk={() => {}}
        onCancel={() => handlecloseThisModal()}
        width={750}
        centered={isDesktop}
        zIndex={9999}
        maskClosable={false}
        footer={[
          <MyButton
            // key="back"
            isPrimary
            onClick={() => handlecloseThisModal()}
            style={{
              width: isDesktop ? "25%" : "100%",
            }}
            // onClick={isEdit ? handleClickCancelEdit : onCancle}
          >
            <FormattedMessage id="btnClose" defaultMessage="Close" />
          </MyButton>,
        ]}
      >
        <Divider className="m-0" />

        <div>
          <div className="d-flex pt-4 mb-2">
            <Form style={{ width: "100%" }} name="x" form={formSearch}>
              <Form.Item name="name">
                <Input
                  allowClear
                  onChange={(e) => handleSerchCustomer(e.target.value)}
                  style={{
                    borderRadius: "20px",
                    // backgroundColor: COLORS.Gray,
                    backgroundColor: "#FFF",
                  }}
                  // value={tempSearch}
                  placeholder={intl.formatMessage({
                    id: "placeholderSearchCustomer",
                    defaultMessage: "Search Customer",
                  })}
                  suffix={
                    <div>
                      <SearchOutlined
                        style={{
                          color: "rgba(0,0,0,.45)",
                        }}
                      />
                    </div>
                  }
                />
              </Form.Item>
            </Form>
          </div>
          <div
            style={{
              overflow: "auto",
              maxHeight: isDesktop ? null : "65vh",
              height: isDesktop ? "40vh" : null,
            }}
          >
            {_.size(customerData) > 0 ? (
              // _.size(tempSearchArray) > 0 ? (
              //   _.map(tempSearchArray, (element, index) => {
              //     return (
              //       <>
              //         {index !== 0 && <Divider className="mx-0 my-3" />}
              //         <CustomerListItem
              //           customer={element}
              //           handleClickCustomer={handleClickCustomer}
              //         />
              //       </>
              //     );
              //   })
              // ) : (
              //   <CustomerListItem
              //     search={tempSearch}
              //     handleClickCustomer={() => handleClickSearchCustomer()}
              //   />
              // )
             _.map(customerData, (element, index) => {
                  return (
                    <>
                      {index !== 0 && <Divider className="mx-0 my-3" />}
                      <CustomerListItem
                        customer={element}
                        handleClickCustomer={handleClickCustomer}
                      />
                    </>
                  );
                })
            ) : (
              <CustomerListItem
                search={tempSearch}
                handleClickCustomer={() => handleClickSearchCustomer()}
              />
            )}
          </div>
        </div>
        {/* <Divider className="mx-0 mt-4 mb-3" /> */}
      </Modal>
      <CustomerModal
        isOpen={isOpenCustomerModal}
        onCancle={handleCancelCustomerForm}
        isSaveCustomer
        form={form}
        setEvent={setEvent}
        customerData={customerData}
        tempDataCus={tempDataCus}
        setTempDataCus={setTempDataCus}
        // createSearch={searchCustomer}
        setIsTemp={setIsTemp}
        isTemp={isTemp}
        // isEdit={isEdit}
      />
    </>
  );
};

export default SelectCustomerModal;
